import React, { useState, useEffect } from 'react';
import styles from './index.module.sass';
import Skeleton from '@mui/material/Skeleton';
import { useTranslation } from 'react-i18next';
import OrderCard from '../../../OrderCard';
import SectionTitle from '../../../SectionTitle';
import TableComponent from '../../../TableComponent';
import { useParams } from 'react-router-dom';
import getInvoicesDetail from '../../../Queries/GetInvoicesDetail';
import Alert from '../../../Alert';

const DetailMyOrders = (props) => {
  const { device, setSessionMessage } = props;
  const { pedido } = useParams();
  const { screenSize } = device;
  const { t } = useTranslation('myOrders');
  const tableItems = t('tableItems', { returnObjects: true });
  const [loading, setLoading] = useState(false);
  const [alertText, setAlertText] = useState('');
  const [open, setOpen] = useState(false);
  const [detailInvoices, setdetailInvoices] = useState([]);
  const [response, setresponse] = useState('');

  useEffect(() => {
    async function get_Detail_Invoice() {
      setLoading(true);

      const response = await getInvoicesDetail(pedido);
      setresponse(response);
      const { typeMessage = 'error', message = '', InvoicesDetail = [] } = response;

      setSessionMessage(message);

      if (typeMessage === 'error') {
        if (message === '498' || message === '499') return false;
        setAlertText(message);
        setOpen(true);
      } else {
        setdetailInvoices(InvoicesDetail);
      }

      setLoading(false);
    }
    get_Detail_Invoice();
  }, [setSessionMessage, pedido]);

  return (
    <div className={`${styles.container} ${styles[screenSize]}`}>
      <div className={styles.orderHeader}>
        <div className={styles.return} onClick={() => window.history.back()}>
          <i className='material-icons-outlined'>navigate_before</i>
          <span className={styles.returnText}>{t('return')}</span>
        </div>
      </div>
      <SectionTitle title={t('titleDetail')} subtitle={t('subTitleDetail')} />
      <Alert open={open} setOpen={setOpen} title={t('alertTitle')} text={alertText} />

      <div className={styles.details}>
        <div className={styles.bloque}>
          <OrderCard
            customStyles={styles.orderCard}
            title={(screenSize === 'phone' && t('order')) || null}>
            {screenSize !== 'phone' && <div className={styles.titleOrder}>{t('order')}</div>}
            <div className={styles.textOrder}>{response.noPedido}</div>
            <div className={styles.titleOrder}>{t('date')}</div>
            <div className={styles.textOrder}>{response.fecha}</div>
          </OrderCard>
        </div>
        <div className={styles.bloque}>
          <OrderCard
            customStyles={styles.orderCard}
            title={(screenSize === 'phone' && t('invoice')) || null}>
            {screenSize !== 'phone' && <div className={styles.titleOrder}>{t('invoice')}</div>}
            <div className={styles.textOrder}>
              <span className={styles.nameOrder}>{t('kit')}</span> {response.kit}
            </div>
            <div className={styles.textOrder}>
              <span className={styles.nameOrder}>{t('consultora')} </span>
              {response.nombreConsultora}
            </div>
          </OrderCard>
        </div>
        <div className={styles.bloque}>
          <OrderCard
            customStyles={styles.orderCard}
            title={(screenSize === 'phone' && t('address')) || null}>
            {screenSize !== 'phone' && <div className={styles.titleOrder}>{t('address')}</div>}
            <div className={styles.textOrder}>{response.direccionEnvio}</div>
          </OrderCard>
        </div>
        <div className={styles.bloque}>
          <OrderCard
            customStyles={styles.orderCard}
            title={(screenSize === 'phone' && t('orderResume')) || null}>
            {screenSize !== 'phone' && <div className={styles.titleOrder}>{t('orderResume')}</div>}
            <div className={styles.textOrder}>
              <span className={styles.nameOrder}>{t('tipoA')}</span> {response.comisionesProducto}
            </div>
            <div className={styles.textOrder}>
              <span className={styles.nameOrder}>{t('tipoB')} </span>
              {response.ayudaVenta}
            </div>
            <div className={styles.textOrder}>
              <span className={styles.nameOrder}>{t('modulosPedido')}</span>{' '}
              {response.modulosPedido}
            </div>
            <div className={styles.textOrder}>
              <span className={styles.nameOrder}>{t('modulosMes')}</span> {response.modulosMes}
            </div>
          </OrderCard>
        </div>
      </div>

      <div className={styles.divBloque}>
        <OrderCard>
          {(loading && (
            <div className={styles.bottomSkeleton}>
              <TableComponent
                screenSize={screenSize}
                tableData={detailInvoices}
                tableItems={tableItems}
              />
              <div className={styles.totalsSkeleton}>
                <Skeleton variant='rectangular' className={styles.loadingText} />
                <Skeleton variant='rectangular' className={styles.loadingText} />
                <Skeleton variant='rectangular' className={styles.loadingText} />
              </div>
            </div>
          )) || (
            <>
              <TableComponent
                screenSize={screenSize}
                tableData={detailInvoices}
                tableItems={tableItems}
              />
              {screenSize === 'phone' ? (
                <div className={styles.totals}>
                  <div className={styles.bottomPage}>
                    <div className={styles.totals}>
                      <div className={styles.totalText}>{t('subtotal')}</div>
                      <div className={styles.totalNumber}>${response.subtotal}</div>
                    </div>

                    <div className={styles.totals}>
                      <div className={styles.totalText}>{t('envio')}</div>
                      <div className={styles.totalNumber}>${response.envio}</div>
                    </div>

                    <div className={styles.totals}>
                      <div className={styles.totalText}>
                        {(process.env.REACT_APP_COUNTRY === 'MX' && t('iva')) || t('taxes')}
                      </div>
                      <div className={styles.totalNumber}>${response.impuestos}</div>
                    </div>

                    <div className={styles.totals}>
                      <div className={styles.totalTextMobile}>{t('total')}</div>
                      <div className={styles.totalNumberMobile}>${response.total}</div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className={styles.totals}>
                  <div className={styles.linkDownload}>
                    {response.url && (
                      <>
                        <div className={styles.download}>
                          <i className={`material-icons-outlined `}>picture_as_pdf</i>
                          <div className={styles.underline}>
                            <a href={response.url} target='_blank' rel='noreferrer'>
                              &nbsp;{t('download')}
                            </a>
                          </div>
                        </div>

                        {process.env.REACT_APP_COUNTRY === 'MX' && (
                          <div className={styles.download}>
                            <i className={`material-icons-outlined `}>picture_as_pdf</i>
                            <div className={styles.underline}>
                              <a href={response.urlXML} target='_blank' rel='noreferrer'>
                                &nbsp;{t('downloadXML')}
                              </a>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                  <div className={styles.bottomPage}>
                    <div className={styles.totals}>
                      <div className={styles.totalText}>{t('subtotal')}</div>
                      <div className={styles.totalNumber}>${response.subtotal}</div>
                    </div>

                    <div className={styles.totals}>
                      <div className={styles.totalText}>{t('envio')}</div>
                      <div className={styles.totalNumber}>${response.envio}</div>
                    </div>

                    <div className={styles.totals}>
                      <div className={styles.totalText}>
                        {(process.env.REACT_APP_COUNTRY === 'MX' && t('iva')) || t('taxes')}
                      </div>
                      <div className={styles.totalNumber}>${response.impuestos}</div>
                    </div>

                    <div className={styles.totals}>
                      <div className={`${styles.totalText} ${styles.bigTotal}`}>{t('total')}</div>
                      <div className={`${styles.totalNumber} ${styles.bigTotal}`}>
                        ${response.total}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </OrderCard>
      </div>
      {screenSize === 'phone' && (
        <div className={styles.linkDownload}>
          {response.url && (
            <>
              <div className={styles.download}>
                <i className={`material-icons-outlined `}>picture_as_pdf</i>
                <div className={styles.underline}>
                  <a href={response.url} target='_blank' rel='noreferrer'>
                    &nbsp;{t('download')}
                  </a>
                </div>
              </div>
              {process.env.REACT_APP_COUNTRY === 'MX' && (
                <div className={styles.download}>
                  <i className={`material-icons-outlined `}>picture_as_pdf</i>
                  <div className={styles.underline}>
                    <a href={response.urlXML} target='_blank' rel='noreferrer'>
                      &nbsp;{t('downloadXML')}
                    </a>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default DetailMyOrders;
